import { render, staticRenderFns } from "./UserPermissionsCrud.vue?vue&type=template&id=4feb743f"
import script from "./UserPermissionsCrud.vue?vue&type=script&lang=js"
export * from "./UserPermissionsCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports